import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/client";
import { Button, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import swal from "sweetalert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const AllHotel = () => {
  const [isloaded, setIsLoaded] = useState(false);
  const [del, setDel] = useState(false);
  const [getList, setGetList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, [currentPage, del]);

  const fetchProducts = async () => {
    setIsLoaded(true);
    const { data } = await apiClient.get("/hotel", {
      pageNumber: currentPage,
    });
    setGetList(data?.products);

    setPageSize(data?.pageCount);
    setIsLoaded(false);
  };

  const handlDeleteById = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You want to Delete Hotel",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        const result = await apiClient.delete("/hotel/delete", { id });
        if (result.ok) {
          swal("Delete Success");
          setDel(!del);
        }
      }
    });
  };

  return (
    <div id="layoutSidenav_content">
      <main>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5 col-md-9 col-lg-6">
              <h2 className="mt-30 page-title">Hotel</h2>
            </div>
            <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
              <Button variant="contained" onClick={(e) => navigate("/")}>
                <i className="fas fa-arrow-left" /> Back
              </Button>
            </div>
          </div>
          <ol className="breadcrumb mb-30">
            <li className="breadcrumb-item">
              <a href="index.html">Dashboard</a>
            </li>
            <li className="breadcrumb-item active">Hotel</li>
          </ol>
          <div className="row"></div>
          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mt-30 mb-30">
              <div className="card-title-2">
                <h4>All Hotels</h4>
              </div>
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>No.</th>
                        <th style={{ width: 100 }}>Image</th>
                        <th>Hotel Name</th>
                        <th>Hotel Category</th>

                        <th>Price</th>
                        <th>Update</th>
                        <th>Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isloaded !== true && getList?.length > 0
                        ? getList?.map((row, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div className="cate-img-5">
                                    <img
                                      src={row?.image ? row?.image[0] : ""}
                                      alt="service-name"
                                    />
                                  </div>
                                </td>
                                <td>{row?.name}</td>

                                <td>{row?.category}</td>

                                <td>$ {row.price}</td>

                                <td className="action-btns">
                                  <Link to="/hotel/update" state={row}>
                                    <Typography className="edit-btn">
                                      <Button
                                        size="small"
                                        variant="contained"
                                        startIcon={<EditIcon />}
                                        color="green"
                                      >
                                        EDIT
                                      </Button>
                                    </Typography>
                                  </Link>
                                </td>
                                <td>
                                  <Typography
                                    className="delete-btn"
                                    onClick={(e) => handlDeleteById(row._id)}
                                  >
                                    <Button
                                      size="small"
                                      variant="contained"
                                      startIcon={<DeleteIcon />}
                                    >
                                      Delete
                                    </Button>
                                  </Typography>
                                </td>
                              </tr>
                            );
                          })
                        : "Loading..."}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            count={pageSize}
            page={currentPage}
            siblingCount={1}
            onChange={(e, value) => setCurrentPage(value)}
          />
        </div>
      </main>
    </div>
  );
};

export default AllHotel;
